export const singleAdditionalDoc = [
    {
        fieldType: 'input',
        label: 'Board Resolution Document',
        name: 'BR',
        props: {
            placeholder: 'Upload Board Resolution Document',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: true,
        },
    },
    {
        fieldType: 'input',
        label: ' MEA File (Axis)',
        name: 'MEA',
        props: {
            placeholder: 'Upload  MEA File (Axis)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
]

export const multipleAdditionalDoc = [
    {
        fieldType: 'file',
        label: 'Web Crawling Screenshot',
        name: 'WEB_CRAWLING',
        props: {
            placeholder: 'Upload Web Crawling Screenshot',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: true,
        },
    },
]